<template>
	<div id="error">
		<el-button
    plain
    @click="open1">
    可自动关闭
  </el-button>
	</div>
</template>

<script>
	export default{
		name:'error',
		data(){
			return{
				
			}
		},
		methods:{
			open1() {
				const h = this.$createElement;
				this.$notify({
					title: '提示',
					message: h('i', { style: 'color: teal'}, '这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案这是提示文案')
				});
			},

		}
	}
</script>

<style scoped>
	#error{
		position: absolute;
		top: 10%;
		z-index: 99;
		left: 50%;
	}
</style>